import { Directive, Input, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[access]',
  standalone: false
})
export class AccessDirective {

  private user = {role:  ['grit']}; //Example

  private accessLevel = ['demeter', 'grit'];
  constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) { }

  @Input()
  set access(level: number){
    const role = this.accessLevel[level];

    if(this.user.role.includes(role)){
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
